import { createAction } from '@reduxjs/toolkit';

export const addPatientSnapshot = createAction('[TrackChanges] addPatientSnapshot');
